export default __webpack_public_path__ + "static/media/phish-in-party-multicolor-logo.040a5ffa.png";